import { usePreparationStore } from "@/store/modules/preparation";
import { useMissionStore } from "@/store/modules/mission";

export default async (to, from, next) => {
  const preparationStore = usePreparationStore();
  const missionsStore = useMissionStore();
  const currentMissionUuid = missionsStore.currentMissionUuid;
  const preparation = await preparationStore.retrievePreparationByMission(currentMissionUuid);

  if (preparation) {
    return next();
  }

  const preparationToCreate = {
    mission: currentMissionUuid,
  };

  try {
    await preparationStore.createPreparation(preparationToCreate);
    return next();
  } catch (e) {
    console.error(e);
    return next();
  }
};
